import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from '@reach/router'
import styled from 'styled-components'

import { banner } from '@ads/front-core/store/sagas/bannerSaga'
import { ISection } from '../interfaces'
import Hero from './Hero'
import OurPotential from './OurPotential'
import SellingFunnel from './SellingFunnel'
import OurPossibilities from './OurPossibilities'
import CampaignParameters from './CampaignParameters'
import SalesBooster from './SalesBooster'
import AdvantagesOfWpADS from './AdvantagesOfWpADS'
import MorePossibilities from './MorePossibilities'
import Recommendations from './Recommendations'
import Contact from './Contact'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng } from '@ads/front-core/locales'
import MarketingAutomation from './MarketingAutomation'

const Body: FC<ISection> = ({ setActiveMenu }) => {
  const dispatch = useDispatch()
  const { search } = useLocation()

  if (search?.includes('authError')) {
    dispatch(
      banner({
        description: lng('landing:errorOccuredDuringSignIn'),
        variant: 'error',
      }),
    )
  }

  return (
    <Container>
      <Hero setActiveMenu={setActiveMenu} />
      <OurPotential setActiveMenu={setActiveMenu} />
      <SalesBooster setActiveMenu={setActiveMenu} />
      <SellingFunnel setActiveMenu={setActiveMenu} />
      <OurPossibilities setActiveMenu={setActiveMenu} />
      <MarketingAutomation setActiveMenu={setActiveMenu} />
      <CampaignParameters setActiveMenu={setActiveMenu} />
      <AdvantagesOfWpADS setActiveMenu={setActiveMenu} />
      <MorePossibilities setActiveMenu={setActiveMenu} />
      <Recommendations setActiveMenu={setActiveMenu} />
      <Contact setActiveMenu={setActiveMenu} />
    </Container>
  )
}

const Container = styled.div`
  max-width: 1440px;
  margin: auto;
  padding: 0 60px;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 0 16px;
    overflow-x: hidden;
  }
`

export default Body
